import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { UpdateEmailEntryResponse } from './config';
import { emailEntriesKeys } from './getEmailEntries';

import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { inboxEntriesKeys } from '../../../Sidebar/api/getInboxEntries';
import { EMAIL_THREAD_PAGE_LIMIT } from '../components/EmailThreadViewer/EmailEntries/EmailEntries';
import { inboxSuggestionsKeys } from '../../../Header/FilterButtons/SearchFilter/api/getInboxSuggestions';

// const url = `${PREFIX_URL}/v01/inbox`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId`;

export type DeleteEmailDTO = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
};
export const deleteEmail = ({
  projectId,
  inboxEntryId,
  emailId,
}: DeleteEmailDTO): Promise<UpdateEmailEntryResponse> => {
  return axios.delete(generateRoutePath(url, { projectId, inboxEntryId, emailId }), {
    ...entryActionCustomValidateOptions,
  });
};

type DeleteEmailOptions = {
  projectId: string;
  inboxEntryId: number;
  config?: MutationConfig<typeof deleteEmail>;
};

export const usePermanentDeleteEmail = ({
  projectId,
  inboxEntryId,
  config,
}: DeleteEmailOptions) => {
  return useMutation({
    onSuccess: () => {
      if (
        queryClient.getQueriesData([
          ...emailEntriesKeys.lists({ projectId, inboxEntryId }),
          EMAIL_THREAD_PAGE_LIMIT,
        ]).length > 1
      ) {
        queryClient.invalidateQueries([
          ...emailEntriesKeys.lists({ projectId, inboxEntryId }),
          EMAIL_THREAD_PAGE_LIMIT,
        ]);
      } else {
        queryClient.invalidateQueries([
          ...inboxEntriesKeys.lists({ projectId }),
          ...inboxSuggestionsKeys.detail({ projectId })
        ]);
      }
    },
    ...config,
    mutationFn: deleteEmail,
  });
};
